export const APP_NAME = 'FlexForce'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'landing'
